export default __webpack_public_path__ + "static/ICCAM_06-b9fcec9b0faa50d64c7440dc10501401.webp";